import {
  KeycloakAuthentication,
} from '@qmulus/ui/api/authentication.ts';

import config from '@/config/config.ts';
import {
  LOGIN_PATH,
} from '@/router/constants.ts';

export const keycloakAuthenticationHandler = new KeycloakAuthentication(
  {
    keycloakConfig: {
      url: config.VITE_APP_AUTH_API,
      realm: config.VITE_APP_TENANT_NAME,
      clientId: 'qmulus',
    },
    loginHandler: {
      path: LOGIN_PATH,
    },
  },
);
